import { PatientSearchFilters, type QuickFilter } from '../types';
import { validateRangeFilter } from './main';

export const validateAge = (selectedFilters: QuickFilter[]) => {
  const ageFilters = selectedFilters.filter(
    (selected) =>
      selected.filterKey === 'AgeFilter' ||
      selected.id.includes(PatientSearchFilters.AgeFilter),
  );

  if (ageFilters.length === 0) {
    return true;
  }

  const tokens = ageFilters.map((f) => f.label);

  if (
    tokens[0] !== PatientSearchFilters.AgeFilter &&
    !ageFilters.some((filter) => filter.filterKey === 'AgeFilter')
  ) {
    tokens.unshift(PatientSearchFilters.AgeFilter);
  }

  const valid = validateRangeFilter(tokens);
  return valid;
};
